import { render, staticRenderFns } from "./LandingTypeSelector.vue?vue&type=template&id=094709a8&scoped=true"
import script from "./LandingTypeSelector.vue?vue&type=script&lang=js"
export * from "./LandingTypeSelector.vue?vue&type=script&lang=js"
import style0 from "./LandingTypeSelector.vue?vue&type=style&index=0&id=094709a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094709a8",
  null
  
)

export default component.exports